const Tooltip = {
  start() {
    $('.tooltip').tooltipster();
  }
};

export default Tooltip;
